module.exports = __webpack_public_path__ + "static/media/noise.5058f6b5.png";